import {makeStyles} from "@mui/styles";
import {Button, Card, CardActions, CardContent, Container, Typography} from "@mui/material";
import React from "react";
import {Helmet} from 'react-helmet'
import useMediaQuery from "@mui/material/useMediaQuery";
import {useTheme} from "@mui/material/styles";
import {LocalizationProvider, useLocalization, useTranslation} from "./LocalizationProvider";
import CustomMenuComponent from "./CustomMenuComponent";


const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%',
    },
    sidebar: {
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        left: 0,
        top: 0,
        zIndex: 3,
        margin: theme.spacing(1.5),
        width: theme.dimensions.drawerWidthDesktop,
        bottom: theme.dimensions.bottomBarHeight,
        transition: 'transform .5s ease',
        backgroundColor: 'white',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            margin: 0,
        },
    },
    sidebarCollapsed: {
        transform: `translateX(-${theme.dimensions.drawerWidthDesktop})`,
        marginLeft: 0,
        [theme.breakpoints.down('md')]: {
            transform: 'translateX(-100vw)',
        },
    },
    toolbarContainer: {
        zIndex: 4,
    },
    toolbar: {
        display: 'flex',
        padding: theme.spacing(0, 1),
        '& > *': {
            margin: theme.spacing(0, 1),
        },
    },
    statusCard: {
        position: 'fixed',
        zIndex: 5,
        [theme.breakpoints.up('md')]: {
            left: `calc(50% + ${theme.dimensions.drawerWidthDesktop} / 2)`,
            bottom: theme.spacing(3),
        },
        [theme.breakpoints.down('md')]: {
            left: '50%',
            bottom: `calc(${theme.spacing(3)} + ${theme.dimensions.bottomBarHeight}px)`,
        },
        transform: 'translateX(-50%)',
    },
    sidebarToggle: {
        position: 'fixed',
        left: theme.spacing(1.5),
        top: theme.spacing(3),
        borderRadius: '0px',
        minWidth: 0,
        [theme.breakpoints.down('md')]: {
            left: 0,
        },
    },
    sidebarToggleText: {
        marginLeft: theme.spacing(1),
        [theme.breakpoints.only('xs')]: {
            display: 'none',
        },
    },
    sidebarToggleBg: {
        backgroundColor: 'white',
        color: 'rgba(0, 0, 0, 0.6)',
        '&:hover': {
            backgroundColor: 'white',
        },
    },
    bottomMenu: {
        position: 'fixed',
        left: theme.spacing(1.5),
        bottom: theme.spacing(1.5),
        zIndex: 4,
        width: theme.dimensions.drawerWidthDesktop,
    },
    filterPanel: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(2),
        gap: theme.spacing(2),
        width: theme.dimensions.drawerWidthTablet,
    },
}));

const HomePageComponent = () => {
    const classes = useStyles();

    const theme = useTheme();
    const phone = useMediaQuery(theme.breakpoints.down('md'));
    const t = useTranslation();
    const {languages, language, setLanguage} = useLocalization();

    return (
        <>
            <Helmet>
                <title>{t('homePage')}</title>
            </Helmet>
            <CustomMenuComponent breadcrumbs={['homePage']}>
                <div className={classes.root}>
                    <Container>
                        <Card variant={"outlined"} sx={{
                            bgcolor: '#eeeeee',
                            marginTop: "3em",
                            minHeight: '25em',
                            width: "100%",
                            padding: phone ? "1em" : "3em"
                        }}>
                            <CardContent>
                                <Typography variant={phone ? 'h4' : 'h3'} component="div">
                                    {t('companyName')}
                                </Typography>
                                <Typography variant={phone ? 'p' : 'h6'}>
                                    <LocalizationProvider>
                                        {language === 'bg' ?
                                            'Адмикс ООД е логистичен партньор на датската фирма Chr. Hansen A/S - световен лидер ' +
                                            'в производството на ингредиенти за хранителната промишленост - закваски за кисело ' +
                                            'мляко и млечни продукти, мая за сирене и кашкавал, стартерни култури за месо, ' +
                                            'натурални оцветители за хранително производство, ингредиенти за вино. Освен ' +
                                            'логистично обслужване, ние Ви предлагаме заедно с любезното сътрудничество на ' +
                                            'технолозите от Chr. Hansen в България, технологична помощ и съдействие директно във ' +
                                            'Вашето предприятие.'
                                            :
                                            'Admix Ltd. is a partner of the Danish company Chr.Hansen A / S – a world leader ' +
                                            'in the production of ingredients for the food industry – starter cultures for yogurt ' +
                                            'and dairy products, coagulants for cheeses, meat starter cultures, natural colors for food production, ' +
                                            'ingredients for wine. Along with the kind collaboration of technologists from Chr. ' +
                                            'Hansen in Bulgaria and besides the logistic services, we offer technological support ' +
                                            'and assistance directly to your company. '}
                                    </LocalizationProvider>
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button variant="contained"
                                        style={{textTransform: "none", backgroundColor: "#337ab7", fontSize: "1.2rem"}}
                                        href="https://www.zakvaski.bg/">
                                    {t('btnSeeMore')} »
                                </Button>
                            </CardActions>
                        </Card>
                        <br/>
                    </Container>
                </div>
            </CustomMenuComponent>
        </>
    );
};

export default HomePageComponent;
